var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 64,
    viewBox: "0 0 105 90",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.1,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5078 31.0906C70.6254 31.0403 70.7519 31.0114 70.8795 31.0054C71.2029 30.9783 71.5358 31.1073 71.7579 31.3458L77.9912 38.1023L84.2245 31.3458C84.4081 31.1491 84.6666 31.0251 84.934 31.0054C85.1174 30.9868 85.3055 31.0164 85.4745 31.0906L104.394 39.8041C105.002 40.083 105.202 40.9956 104.766 41.506L98.8871 48.4326L104.766 55.3421C105.202 55.8525 105.002 56.7651 104.394 57.044L98.5324 59.75V70.2068C98.5293 70.6225 98.2675 71.025 97.8905 71.1939L78.4135 79.9074C78.138 80.0308 77.8106 80.0308 77.5351 79.9074L58.0919 71.1939C57.7149 71.025 57.4532 70.6225 57.45 70.2068V59.75L51.5883 57.044C50.9801 56.7651 50.8629 55.8427 51.2167 55.3421L57.0952 48.4326L51.2167 41.506C50.8355 40.975 50.9801 40.083 51.5883 39.8041L70.5078 31.0906ZM76.1668 39.3276L70.7105 33.4051L53.8012 41.1997L58.8352 47.1051L76.1668 39.3276ZM85.2718 33.4051L102.181 41.1997L97.1472 47.1051L79.8156 39.3276L85.2718 33.4051ZM94.7823 48.4326L77.9912 40.9103L61.2001 48.4326L77.9912 55.9378L94.7823 48.4326ZM58.8352 49.743L76.1668 57.5205L70.7105 63.443L53.8012 55.6485L58.8352 49.743ZM102.181 55.6485L97.1472 49.743L79.8156 57.5205L85.2718 63.443L102.181 55.6485ZM76.9101 59.9202V77.2355L59.6122 69.492V60.7371L70.5078 65.7576C70.921 65.9489 71.4513 65.8406 71.7579 65.5023L76.9101 59.9202ZM84.2245 65.5023L79.0723 59.9202V77.2185L96.3702 69.492V60.7371L85.4745 65.7576C85.0614 65.9489 84.5311 65.8406 84.2245 65.5023Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7861 26.6258L81.5017 20.1379C81.6403 19.6129 81.3284 19.0756 80.8047 18.9376C80.2808 18.8 79.7441 19.113 79.6052 19.6379L79.6055 19.6378L78.4611 23.9641C76.0984 18.6936 73.1156 15.2903 70.0688 13.1565C66.4892 10.6464 62.8594 9.90433 60.1417 9.79602C57.4201 9.68751 55.5952 10.2009 55.5249 10.2199C55.0036 10.3683 54.6999 10.9114 54.8466 11.4334C54.9103 11.6601 55.0488 11.8454 55.2271 11.9704C55.4599 12.1335 55.762 12.1943 56.0569 12.1108L56.0571 12.1105C56.0571 12.1105 56.0571 12.1105 56.0634 12.1091C56.199 12.0716 57.8812 11.6394 60.2903 11.7704C62.7026 11.9023 65.8282 12.5852 68.9419 14.7672C71.6845 16.6914 74.4446 19.7921 76.6897 24.8137L72.4369 23.7292C71.9122 23.5953 71.3773 23.9131 71.243 24.4392C71.139 24.847 71.3058 25.2599 71.6305 25.4873C71.7246 25.5532 71.832 25.6037 71.9504 25.6341L78.5946 27.3279C79.1165 27.4606 79.6483 27.1472 79.7861 26.6258Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1572,
    y: 0.68457,
    width: 46,
    height: 32,
    transform: "rotate(21 14.1572 0.68457)",
    strokeWidth: 2.2,
    rx: 0,
    ry: 0,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8989 12.8686L34.4311 42.7432",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6163 35.5585C44.6475 35.9543 45.8044 35.4393 46.2002 34.4081C46.596 33.3768 46.081 32.22 45.0498 31.8242C44.0186 31.4283 42.8617 31.9434 42.4659 32.9746C42.07 34.0058 42.5851 35.1626 43.6163 35.5585Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4659 41.1591C42.4971 41.5549 43.654 41.0398 44.0498 40.0086C44.4457 38.9774 43.9306 37.8206 42.8994 37.4247C41.8682 37.0289 40.7113 37.544 40.3155 38.5752C39.9196 39.6064 40.4347 40.7632 41.4659 41.1591Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3902 19.4043L54.5931 23.7047",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.05666 35.3682L9.65814 37.5184",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7984 47.5527L41.3998 49.7029",
    strokeWidth: 2.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 110,
    rx: 0,
    ry: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight50);
export default __webpack_public_path__ + "static/media/weight_50.c5896ca5ddfee48545527917245884b0.svg";
export { ForwardRef as ReactComponent };